/**
 * Libellés référentiels / domaines selon la langue UI.
 */
export function isFrench(lang?: string): boolean {
  return (lang ?? "fr").toLowerCase().startsWith("fr");
}

export function localeLabel(
  lang: string | undefined,
  item: { labelFr?: string | null; labelEn?: string | null; label?: string | null; code?: string | null }
): string {
  const fallback = item.label || item.code || "";
  const fr = item.labelFr || fallback;
  const en = item.labelEn || item.labelFr || fallback;
  return isFrench(lang) ? fr : en;
}
